module.exports = __webpack_public_path__ + "img/puesta-en-valor.7603e081.jpg";